
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { findMarketForStart } from './app/market/market-resolver';
import { setAppMarket } from './app/market/market.token';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * The market must be known BEFORE any app code runs (D23): some configuration is read while the modules
 * load (the cookie banner config, the date pipe default). That is why the AppModule is imported
 * DYNAMICALLY, only after setAppMarket() – a normal "import { AppModule }" at the top of this file would
 * run all of that code first, with the wrong (default) market.
 */
async function startApp(): Promise<void> {
  setAppMarket(await findMarketForStart());
  const { AppModule } = await import('./app/app.module');
  await platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
}

startApp().catch(err => console.error(err));
